<template>
  <div>
    <Skeleton
      v-if="isSkeletonVisible"
      height="40px"
    />
    <div
      v-else
      class="availability-big-ticket"
    >
      <NotAvailable
        v-if="showNotAvailableComponent"
        :current-zip-code="zipCode"
      />
      <ShipToZipCode
        v-else-if="showShipToZipCodeComponent"
        :current-zip-code="zipCode"
        :availability-message="deliverabilityMessageForCurrentUpc"
        :big-ticket-available="bigTicketAvailableForCurrentUpc"
      />
      <NoZipCode v-else-if="showNoZipCodeComponent" />
    </div>
  </div>
</template>
<script setup>
import { computed, onMounted } from 'vue';
import { useMounted } from '@vueuse/core';
import Skeleton from '@common-vue/atomic-ui/src/components/skeleton';
import NotAvailable from './NotAvailable';
import NoZipCode from './NoZipCode';
import ShipToZipCode from './ShipToZipCode';
import { useAvailabilityBigTicket } from '../composables/useAvailabilityBigTicket';

const {
  bigTicketAvailableForCurrentUpc,
  deliverabilityMessageForCurrentUpc,
  showShipToZipCodeComponent,
  showNotAvailableComponent,
  showNoZipCodeComponent,
  zipCode,
  setZipCode,
  dataLoadNeeded,
  isDataLoaded,
} = useAvailabilityBigTicket();

const isMounted = useMounted();

const isSkeletonVisible = computed(() => !isMounted.value || (dataLoadNeeded.value && !isDataLoaded.value));

onMounted(() => {
  setZipCode();
});
</script>
